<div class="sub-header" *ngIf="currentReport">
  <div class="container" style="height: 60px;">
    <div class="controls-panel">
      <div class="header">
        <h1 class="hinted">
          {{currentReport.COMPANY_NAME ? currentReport.COMPANY_NAME : 'Report Information'}}
          <div class="hint" *ngIf="currentReport.COMPANY_DBA">{{currentReport.COMPANY_DBA}}</div>
        </h1>
        <!-- <div class="desc">Location - Z:\Reliant Archive\190119 - {{currentReport.COMPANY_NAME}}</div>-->
      </div>

      <div class="actions-wrapper">
        <button type="button" class="btn btn-rbv" id="backButton" routerLink="/">
          <fa name="fa fa-angle-left"></fa> Back
        </button>

        <button type="button" *ngIf="currentReport.REPORT_QUOTE" class="btn btn-rbv info" (click)="onQuote()">
          Quote
        </button>

         <button *ngIf="currentReport.STAGE.ID === 'EAID' || currentReport.STAGE.ID === 'EAQD'" type="button"
           class="btn btn-rbv warning" (click)="onMerge()">
           <fa name="fa fa-compress"></fa> Merge
         </button>

           <button *ngIf="currentReport.PARENT_ID" type="button" class="btn btn-rbv" (click)="gotoParent()">
             <fa name="fa fa-external-link"></fa> Parent
           </button>

        <button type="button" class="btn btn-rbv warning hinted" (click)="delayModalAction()"
                *ngIf="currentReport.STATE.ID !== 'CMP' && currentReport.STATE.ID !== 'CCD' && currentReport.STATE.ID !== 'LST' && currentReport.STATE.ID !== 'MRD'">
          {{currentReport.STATE.ID === 'RDL' ? 'End Delay' : 'Delay'}}
          <div class="hint">Manage Report Delays</div>
        </button>

        <button type="button" class="btn btn-rbv hinted" (click)="changeStage()"
                *ngIf="currentReport.STATE.ID !== 'CMP' && currentReport.STATE.ID !== 'CCD' && currentReport.STATE.ID !== 'LST' && currentReport.STATE.ID !== 'MRD'">
          Stage
          <div class="hint">Change Report Stage</div>
        </button>

      </div>
    </div>
  </div>
</div>

<div class="report-header" *ngIf="currentReport">
  <div class="container">
    <div class="report-header-wrapper">
      <div class="report-menu">
        <div class="wrapper-left">
          <div class="header-item" [routerLink]="['/report-ea', currentReport.ID, 'general']" routerLinkActive="active">
            General
          </div>

          <div class="header-item" [routerLink]="['/report-ea', currentReport.ID, 'history']" routerLinkActive="active">
            Edits & History
          </div>

          <div class="header-item" [routerLink]="['/report-ea', currentReport.ID, 'links']" routerLinkActive="active">
            Links
          </div>

          <div class="header-item" [routerLink]="['/report-ea', currentReport.ID, 'notes']" routerLinkActive="active">
            Notes
          </div>

          <div class="header-item" [routerLink]="['/report-ea', currentReport.ID, 'files']" routerLinkActive="active">
            Files
          </div>

          <div class="header-item" [routerLink]="['/report-ea', currentReport.ID, 'emails']" routerLinkActive="active">
            Emails
          </div>

          <div class="header-item" [routerLink]="['/report-ea', currentReport.ID, 'export']" routerLinkActive="active">
            Export
          </div>

        </div>

        <div class="wrapper-right">

          <div class="status hinted" [ngClass]="{'delayed': currentReport.STATE.ID === 'RDL'}">
            {{currentReport.STATE?.NAME}}
            <div class="hint">Report Status</div>
          </div>

          <div class="watch hinted">
            <button type="button" class="btn top-lock-button" (click)="onLockChange()">
              <ng-container *ngIf="isLocked">
                <fa class="check-block" name="fa fa-lock"></fa>
                <div class="hint">Report Unlock</div>
              </ng-container>

              <ng-container *ngIf="!isLocked">
                <fa class="check-block" name="fa fa-unlock-alt"></fa>
                <div class="hint">Report Lock</div>
              </ng-container>

            </button>
          </div>

          <watch hint="Watch options"></watch>

          <div class="watch btn-rbv-dropdown hinted" dropdown>
            <button dropdownToggle type="button" class="btn top-nav-button">
              <fa class="check-block" name="fa fa-ellipsis-h"></fa>
              <div class="hint">Report options</div>
            </button>

            <div *dropdownMenu class="drop-menu dropdown-menu-right rounded-0 width-200">
              <a *ngIf="currentReport.STAGE?.ORDER < 4" class="drop-item" (click)="deleteReport()">
                <fa class="check-block" name="fa fa-trash" style="width: 20px;color: red;"></fa>
                <div class="item">Delete</div>
              </a>

              <a class="drop-item" *ngIf="currentReport.STATE.ID !== 'CCD'" (click)="cancelReport()">
                <fa class="check-block" name="fa fa-ban" style="width: 20px;color: red;"></fa>
                <div class="item">Cancel </div>
              </a>

              <a class="drop-item" (click)="revertReport()">
                <fa class="check-block" name="fa fa-undo" style="width: 20px;color: #ffae00;"></fa>
                <div class="item">Revert </div>
              </a>

              <a class="drop-item" *ngIf="currentReport.STATE.ID !== 'CCD'" (click)="refreshReport()">
                <fa class="check-block" name="fa fa-refresh" style="width: 20px;color: #aba8a8;"></fa>
                <div class="item">Refresh </div>
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<div class="container report">
   <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
